import {Fragment, h} from "preact";
import {useAppContext, useBehavioralContext} from "../../../../contexts";
import TermsList from "./TermsList";
import {ProductCardV2} from "../../../index";
import s from "./searchBlock.module.css";

const SearchBlock = (props) => {
    const {vendor} = props;

    // Retrieves the search bar action stuff
    const {
        searchBarData,
        handleSearchBar
    } = useBehavioralContext();

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Flags whether the component should be displayed or not
    const shouldOpen =
        searchBarData["isOpen"] && !Array.isArray(searchBarData.data);

    // Variable in which all suggested products will be listed into
    const suggestionList =
        shouldOpen ?
            searchBarData.data.products.map((item, index) => {
                if(vendor !== "DEFAULT" && !!item.tablePrice?.price == false){
                    console.log(`search: tabela de preço não configurada para ${item.name}`);
                    return;
                };
                return (
                    <ProductCardV2
                        key={item.id}
                        product={item}
                        index={index}
                        handleClick={() => {}}
                        fixedWidth={false}
                        vendor={vendor}
                    />
                )
            }) : null;

    // The main content variable
    const content =
        (
            shouldOpen &&
            searchBarData.data.products.length === 0 &&
            searchBarData.data.terms.length === 0
        ) ? (
            <div className={"py-8"}>
                <p
                    className={`font-museo text-gray-500 px-4 text-center py-1.5 text-base ${highContrast ? "!text-[#fecc31]" : ""}`}
                    data-testid="location-picker-label"
                >
                    Nenhum produto encontrado!
                </p>
            </div>
        ) : (
            <Fragment>
                <TermsList
                    handleSearchBar={handleSearchBar}
                    data={searchBarData.data.terms}
                />
                <div className={"w-full pt-8 md:pt-12 pb-14 md:pb-20"}>
                    <div className={"w-full px-0 md:px-3"}>
                        <div className={"font-museo"}>
                            <h2 className={`${s.subHeading} ${highContrast ? s.dmSubHeading : ""}`}>
                                Sugestões:
                            </h2>
                            <div className={"grid grid-cols-2 w-full gap-x-4"}>
                                {suggestionList}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )

    return (
        <Fragment>
            <div className={`${s.openDropdownContainer} ${highContrast ? "!bg-[#111] !border-[#2f2f2f]" : ""} ${shouldOpen ? "" : "hidden"}`}>
                <div className={`${s.content} ${s.hideScrollbar}`}>
                    {content}
                </div>
            </div>
        </Fragment>
    )
}

export default SearchBlock;
